import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import {
    clientDataStore,
    oneClient,
} from '../../../../../../../../redux/slices/clientsSlice';
import { Col, Row } from 'antd';
import { allTimings } from '../../../../../../../../redux/slices/communicationSlice';
import FlexWrapper from '../../../../../../../../components/FlexWrapper/FlexWrapper';
import Spacer from '../../../../../../../../components/Spacer/Spacer';
import { standartTimings as defaultTimings } from '../../../../../../../../pages/UserCommunicationPage/SubPages/UserCommunicationTimingsPage/data';

export default function StandartReminders({ data }) {
    const client = useSelector(oneClient);
    const reduxTimings = useSelector(allTimings);
    const dataStore = useSelector(clientDataStore);

    const standartTimings = useMemo(() => {
        if (!reduxTimings?.length) return defaultTimings;

        const communicationTypes = ['email', 'phone', 'email_and_phone'];
        let merged = [...reduxTimings];

        communicationTypes.forEach((type) => {
            const hasType = reduxTimings.some(
                (el) => el.communication_type === type,
            );
            if (!hasType) {
                const defaults = defaultTimings.filter(
                    (el) => el.communication_type === type,
                );
                merged = [...merged, ...defaults];
            }
        });

        return merged;
    }, [reduxTimings]);

    const emailFlowReminders = standartTimings?.filter(
        (el) => el.communication_type === 'email',
    );
    const smsFlowReminders = standartTimings?.filter(
        (el) => el.communication_type === 'phone',
    );
    const emailAndPhoneFlowReminders = standartTimings?.filter(
        (el) => el.communication_type === 'email_and_phone',
    );
    const numberSuffix = {
        1: 'st',
        2: 'nd',
        3: 'rd',
        4: 'th',
    };
    return (
        <div>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - User communication - Timings - Welcome reminders`}</title>
            </Helmet>
            <div className="details-table-wrapper">
                <div className="table-top-pannel">
                    <div className="table-top-pannel__info">
                        <h2 className="table-top-pannel__title">
                            Standart reminders
                        </h2>
                    </div>
                </div>
                {dataStore?.welcome_priority === 'email' && (
                    <div>
                        <Row>
                            <Col span={5}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Email flow
                                </span>
                            </Col>
                            <Col span={3}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Day
                                </span>
                            </Col>
                            <Col span={5}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Templates
                                </span>
                            </Col>
                        </Row>
                        {emailFlowReminders.map((reminder, i) => (
                            <div key={i}>
                                <Row>
                                    <Col span={5}>
                                        <FlexWrapper align="center">
                                            <span className="timings-label">
                                                {`${i + 1}${
                                                    numberSuffix[i + 1]
                                                } welcome reminder`}
                                            </span>
                                        </FlexWrapper>
                                    </Col>
                                    <Col span={3}>
                                        <FlexWrapper align="center">
                                            <p>{reminder.day}</p>
                                        </FlexWrapper>
                                    </Col>
                                    <Col span={5}>
                                        <FlexWrapper direction="column">
                                            <p>
                                                {reminder.template_priority[0]}
                                            </p>
                                            {reminder
                                                ?.template_priority?.[1] && (
                                                <p>
                                                    {
                                                        reminder
                                                            .template_priority[1]
                                                    }
                                                </p>
                                            )}
                                        </FlexWrapper>
                                    </Col>
                                </Row>
                                <Spacer size={4} />
                            </div>
                        ))}
                    </div>
                )}
                {dataStore?.welcome_priority === 'phone' && (
                    <div>
                        <Row>
                            <Col span={5}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Sms flow
                                </span>
                            </Col>
                            <Col span={3}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Day
                                </span>
                            </Col>
                            <Col span={5}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Templates
                                </span>
                            </Col>
                        </Row>
                        {smsFlowReminders.map((reminder, i) => (
                            <div key={i}>
                                <Row>
                                    <Col span={5}>
                                        <FlexWrapper align="center">
                                            <span className="timings-label">
                                                {`${i + 1}${
                                                    numberSuffix[i + 1]
                                                } welcome reminder`}
                                            </span>
                                        </FlexWrapper>
                                    </Col>
                                    <Col span={3}>
                                        <FlexWrapper align="center">
                                            <p>{reminder.day}</p>
                                        </FlexWrapper>
                                    </Col>
                                    <Col span={5}>
                                        <FlexWrapper direction="column">
                                            <p>
                                                {reminder.template_priority[0]}
                                            </p>
                                            {reminder
                                                ?.template_priority?.[1] && (
                                                <p>
                                                    {
                                                        reminder
                                                            .template_priority[1]
                                                    }
                                                </p>
                                            )}
                                        </FlexWrapper>
                                    </Col>
                                </Row>
                                <Spacer size={4} />
                            </div>
                        ))}
                    </div>
                )}
                {dataStore?.welcome_priority === 'email_and_phone' && (
                    <div>
                        <Row>
                            <Col span={5}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Email and Phone flow
                                </span>
                            </Col>
                            <Col span={3}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Day
                                </span>
                            </Col>
                            <Col span={5}>
                                <span
                                    className="input-label"
                                    style={{ marginBottom: '16px' }}
                                >
                                    Templates
                                </span>
                            </Col>
                        </Row>
                        {emailAndPhoneFlowReminders.map((reminder, i) => (
                            <div key={i}>
                                <Row>
                                    <Col span={5}>
                                        <FlexWrapper align="center">
                                            <span className="timings-label">
                                                {`${i + 1}${
                                                    numberSuffix[i + 1]
                                                } welcome reminder`}
                                            </span>
                                        </FlexWrapper>
                                    </Col>
                                    <Col span={3}>
                                        <FlexWrapper align="center">
                                            <p>{reminder.day}</p>
                                        </FlexWrapper>
                                    </Col>
                                    <Col span={5}>
                                        <FlexWrapper direction="column">
                                            <p>
                                                {reminder.template_priority[0]}
                                            </p>
                                            {reminder
                                                ?.template_priority?.[1] && (
                                                <p>
                                                    {
                                                        reminder
                                                            .template_priority[1]
                                                    }
                                                </p>
                                            )}
                                        </FlexWrapper>
                                    </Col>
                                </Row>
                                <Spacer size={4} />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
